import { render, staticRenderFns } from "./EcoloDefi.vue?vue&type=template&id=7396e96e&scoped=true&"
import script from "./EcoloDefi.vue?vue&type=script&lang=js&"
export * from "./EcoloDefi.vue?vue&type=script&lang=js&"
import style0 from "./EcoloDefi.vue?vue&type=style&index=0&id=7396e96e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7396e96e",
  null
  
)

export default component.exports